import { FC } from 'react';

import { ReactComponent as StarIcon } from 'assets/icons/testimonialStar.svg';

import styles from './styles.module.scss';

interface CardProps {
  name: string;
  title: string;
  company: string;
  testimonial: string;
}

const Card: FC<CardProps> = ({ name, title, company, testimonial }) => {
  return (
    <div className={styles.card}>
      <div className={styles.text}>
        <StarIcon className={styles.icon} />
        <p className={styles.testimonial}>"{testimonial}"</p>
      </div>
      <div className={styles.info}>
        <p className={styles.name}>{name}</p>
        <p className={styles.title}>{title}</p>
        <p className={styles.company}>{company}</p>
      </div>
    </div>
  );
};

export default Card;
